import { useCallback, useState } from 'react';
import walletRepository from '../../../repositories/wallet/wallet-repository';
import { useAppSelector } from '../../redux';
import { env } from '../../../..';

export enum PrevinetServiceType {
  FondiPensione = 'FONDI_PENSIONE',
  SustainableFuture = 'SUSTAINABLE_FUTURE',
}

export interface PrevinetLogic {
  previnetToken: string;
  isRequestLoading: boolean;
  isRequestError: boolean;
  getPrevinetUrl: (serviceType: PrevinetServiceType) => string;
  getPrevinetToken: (serviceType: PrevinetServiceType) => void;
  clear: () => void;
}

export const usePrevinetLogic = (): PrevinetLogic => {
  const { token } = useAppSelector((state) => state.data.user);

  const [previnetToken, setPrevinetToken] = useState<string>();
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [isRequestError, setIsRequestError] = useState(false);

  const getPrevinetToken = useCallback(
    (serviceType: PrevinetServiceType) => {
      setIsRequestLoading(true);
      walletRepository
        .getPrevinetAccessToken(token, serviceType)
        .then((value) => {
          setPrevinetToken(value.accessToken);
          setIsRequestLoading(false);
        })
        .catch((_) => {
          setIsRequestError(true);
        });
    },
    [token]
  );

  const getPrevinetUrl = (serviceType: PrevinetServiceType) => {
    switch (serviceType) {
      case PrevinetServiceType.SustainableFuture:
        return env.previnetSustainableFutureUrl;
      case PrevinetServiceType.FondiPensione:
      default:
        return env.previnetUrl;
    }
  };

  const clear = useCallback(() => {
    setPrevinetToken(undefined);
    setIsRequestError(false);
  }, [setPrevinetToken]);

  return {
    previnetToken,
    isRequestLoading,
    isRequestError,
    getPrevinetUrl,
    getPrevinetToken,
    clear,
  };
};
